import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../common/apiEndPoint';
import { map } from 'rxjs/operators';

@Injectable()
export class ForgotPasswordService {
  constructor(private httpClient: HttpClient, private urlSignature: UrlSignature) {}

  sendTokenMail(emailId: string): Observable<string> {
    return this.httpClient
      .get(this.urlSignature.sendTokenUrl + emailId + '/')
      .pipe(map((response) => response as string));
  }
}
